<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row

    >
      <v-col
        v-if="enabled === false && yearEnabled !== ''">
        <v-alert
          :value="true"
          type="error"
          class="white--text"
          transition="scale-transition">
          Sorry, the Learning Portfolio is only enabled for students Year {{ yearEnabled }} or above.
        </v-alert>
      </v-col>
      <v-col
        v-if="enabled && portfolioEntries.length === 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          Your child has not added anything to their portfolio yet.
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        v-for="(portfolioEntry, psid) in orderedPortfolio"
        :key="psid">
        <spotlight-card
          :assigned-walt="portfolioEntry"
          :enable-comment-button="false" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SpotlightCard from '../components/SpotlightCard'
var orderBy = require('lodash.orderby')

export default {
  components: {
    SpotlightCard
  },

  data: () => ({
    portfolioEntries: {},
    enabled: false,
    yearEnabled: 0
  }),
  computed: {
    orderedPortfolio: function () {
      if (Object.keys(this.portfolioEntries).length > 0) { // Check if assignedwalts array is not empty
        return orderBy(this.portfolioEntries, 'order', 'desc')
      } else {
        return this.portfolioEntries
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      // Get Portfolio Entries
      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/spotlightV2/portfolioV2')
        .then(resp => {
          vm.portfolioEntries = resp.data.portfolio
          vm.enabled = resp.data.enabled
          vm.yearEnabled = resp.data.year_enabled
          vm.$store.commit('loading', false)
        })
    })
  }
}
</script>
